import _toConsumableArray from '@babel/runtime/helpers/toConsumableArray';
import { useDirectionContext, Direction } from '../../../contexts/session/Locale.js';

var ANIMATION_ITERATION_INFINITE = 'animation-iteration-infinite';
var ANIMATION_DIRECTION_REVERSE = 'animation-direction-reverse';
var useShimmer = function useShimmer() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
      repeat: true
    },
    repeat = _ref.repeat;
  var direction = useDirectionContext();
  return {
    adsClass: ['shimmer', 'animation-duration-default'].concat(_toConsumableArray(repeat ? [ANIMATION_ITERATION_INFINITE] : []), _toConsumableArray(direction === Direction.RTL ? [ANIMATION_DIRECTION_REVERSE] : []))
  };
};

export { useShimmer };
//# sourceMappingURL=useShimmer.js.map
